import qs from "qs";
import { useCallback } from "react";
import useSWR from "swr";

import { useSWRHooksConfig } from "@touchtech/web-hooks";

import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { api, createCollectionsByStoreUrl } from "@is/services/api";
import { CollectionsResponse } from "@is/types";

type Props = {
  filterOutOfStockItems?: boolean;
};

export const useCollections = ({ filterOutOfStockItems }: Props) => {
  const storeId = LocalStorageService.getItem(LocalStorageKeys.StoreId);
  const url = createCollectionsByStoreUrl(storeId);
  const queryString = qs.stringify({
    filterOutOfStockItems,
  });

  const { data, error, isLoading } = useSWR(`${url}?${queryString}`, api.get);
  const swrConfig = useSWRHooksConfig();

  const revalidateCollections = useCallback(
    () => swrConfig.mutate(`${url}?${queryString}`),
    [url, swrConfig, queryString]
  );

  return {
    collections: data as CollectionsResponse,
    isLoading,
    error,
    revalidateCollections,
  };
};
